<template>
  <div class="app-container">
    <vxe-modal
      v-model="$parent.showMap"
      :fullscreen="false"
      :width="'90vw'"
      :height="'90vh'"
      :min-height="160"
      show-footer
      :transfer="true"
      :destroy-on-close="true"
    >
      <template #title>
        <span>地图选择</span>
      </template>
      <template #default>
        <el-autocomplete
          v-model="mapLocation.address"
          :fetch-suggestions="querySearch"
          placeholder="请输入详细地址搜索"
          :trigger-on-focus="false"
          :scroll-wheel-zoom="true"
          @select="handleSelect"
          class="my_inp"
        />
        <div class="bm-view-wrap">
          <baidu-map
            class="bm-view"
            :center="mapCenter"
            :zoom="mapZoom"
            :scroll-wheel-zoom="true"
            ak="baidu-ak"
            @ready="handlerBMap"
          />
        </div>
        <div class="tools_wrap" v-if="chosenPoint">
          <div class="point_wrap">
            <span class="info">经度：</span>
            {{chosenPoint.lng}}
            <span class="info">纬度：</span>
            {{chosenPoint.lat}}
          </div>
        </div>
      </template>
      <template #footer>
        <vxe-button size="mini" @click="$parent.showMap=false">取消</vxe-button>
        <vxe-button
          size="mini"
          status="primary"
          @click="confirm"
        >确认</vxe-button>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
export default {
  name: "CommonPositionChoose",
  props:['showMap'],
  components: {
    BaiduMap
  },
  data() {
    return {
      mapZoom: 10,
      mapCenter: { lat: 0, lng: 0 },
      chosenPoint: null,
      mapLocation: {
        address: undefined,
        coordinate: undefined
      }
    };
  },
  methods: {
    confirm() {
        if(this.chosenPoint){
            this.$parent.confirmPosition(this.chosenPoint)
            this.$parent.showMap=false
        }else{
            this.$message.warning('您还没选择位置')
        }
    },
    handlerBMap({ BMap, map }) {
      this.BMap = BMap;
      this.map = map;
      if (this.mapLocation.coordinate && this.mapLocation.coordinate.lng) {
        this.mapCenter.lng = this.mapLocation.coordinate.lng;
        this.mapCenter.lat = this.mapLocation.coordinate.lat;
        this.mapZoom = 15;
        map.addOverlay(new this.BMap.Marker(this.mapLocation.coordinate));
      } else {
        this.mapCenter.lng = 121.4423799927053;
        this.mapCenter.lat = 28.62668923584285;
        this.mapZoom = 10;
      }
      map.disableDoubleClickZoom() 
      map.addEventListener("dblclick", e => {
        this.makerCenter(e.point);
        return false
      });
    },
    querySearch(queryString, cb) {
      var that = this;
      var myGeo = new this.BMap.Geocoder();
      myGeo.getPoint(
        queryString,
        function(point) {
          if (point) {
            that.mapLocation.coordinate = point;
            that.makerCenter(point);
          } else {
            that.mapLocation.coordinate = null;
          }
        },
        this.locationCity
      );
      var options = {
        onSearchComplete: function(results) {
          if (local.getStatus() === 0) {
            // 判断状态是否正确
            var s = [];
            for (var i = 0; i < results.getCurrentNumPois(); i++) {
              var x = results.getPoi(i);
              var item = { value: x.address + x.title, point: x.point };
              s.push(item);
              cb(s);
            }
          } else {
            cb();
          }
        }
      };
      var local = new this.BMap.LocalSearch(this.map, options);
      local.search(queryString);
    },
    handleSelect(item) {
      var { point } = item;
      this.mapLocation.coordinate = point;
      this.makerCenter(point);
    },
    makerCenter(point) {
      if (this.map) {
        this.map.clearOverlays();
        this.map.addOverlay(new this.BMap.Marker(point));
        this.mapCenter.lng = point.lng;
        this.mapCenter.lat = point.lat;
        this.chosenPoint=point
        this.mapZoom = 15;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.app-container {
    width: 100%;
    height: 100%;
    position: relative;
}
.my_inp {
    position: absolute;
    width: 500px !important;
    z-index: 111 !important;
    left: 20px;
    top: 20px;
}
.bm-view-wrap {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
}
.bm-view {
    width: 100%;
    height: 100%;
}
.tools_wrap {
    background: #fafafa;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    border-top: 1px solid #cccccc;
    box-shadow: 0 -3px 3px rgba($color: #000000, $alpha: 0.1);
    z-index: 1;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 10px 30px 10px;
    box-sizing: border-box;
}
.point_wrap {
    padding-right: 20px;
    .info {
        color: #409eff;
        font-weight: bold;
        margin-left: 20px;
    }
}
</style>